<!-- NOTE: the stickyWrapperClass="mb-2" is added on the <wl-receipt> to match the mb-2 of the last order-step -->
@if (rendering && product$ | async; as product) {
  <wl-receipt
    [wlTrackProduct]="{
      rendering: rendering,
      track: product,
      trackingConfig: trackProductConfig,
      trackMode: 'product-detail',
    }"
    [title]="
      title
        | interpolate
          : {
              variables: {
                savings:
                  product.yearlySavings | currency: 'EUR' : 'symbol' : '1.0-0',
              },
            }
    "
    [sticky]="true"
    stickyWrapperClass="mb-2"
  >
    <ng-template wlReceiptBreakdown>
      <div>
        <wl-receipt-breakdown-row class="mb-2" [hasRightPart]="true">
          <ng-container leftProjection
            ><span *scText="amountAndTypeOfPanelsLabelField"></span
          ></ng-container>
          <ng-template rightProjection
            ><span
              *scText="
                amountAndTypeOfPanelsValueField
                  | interpolate
                    : {
                        variables: {
                          amount: product.recommendation.amount,
                          panelType: product.content.title,
                        },
                      }
              "
            ></span
          ></ng-template>
        </wl-receipt-breakdown-row>
        <wl-receipt-breakdown-row class="mb-2" [hasRightPart]="true">
          <ng-template leftProjection
            ><span *scText="productGuaranteeLabelField"></span
          ></ng-template>
          <ng-template rightProjection
            ><span
              *scText="
                productGuaranteeValueField
                  | interpolate
                    : {
                        variables: {
                          amount: product.productGuarantee,
                        },
                      }
              "
            ></span
          ></ng-template>
        </wl-receipt-breakdown-row>
        <wl-receipt-breakdown-row class="mb-2" [hasRightPart]="true">
          <ng-template leftProjection
            ><span *scText="powerGuaranteeLabelField"></span
          ></ng-template>
          <ng-template rightProjection
            ><span
              *scText="
                powerGuaranteeValueField
                  | interpolate
                    : {
                        variables: {
                          amount: product.performanceGuaranteedAfterYears,
                        },
                      }
              "
            ></span
          ></ng-template>
        </wl-receipt-breakdown-row>
        <wl-receipt-breakdown-row [separator]="true" [hasRightPart]="true">
          <ng-template leftProjection
            ><span *scText="estimatedYearlyRevenueLabelField"></span
          ></ng-template>
          <ng-template rightProjection
            ><span
              *scText="
                estimatedYearlyRevenueValueField
                  | interpolate
                    : {
                        variables: {
                          yearlyYield: product.recommendation.yearlyYield,
                        },
                      }
              "
            ></span
          ></ng-template>
        </wl-receipt-breakdown-row>
      </div>
    </ng-template>
    <ng-template wlReceiptConclusion>
      <wl-receipt-breakdown-row [hasRightPart]="true">
        <ng-template leftProjection>
          <strong><span *scText="savingsPerYearLabelField"></span></strong>
          <wl-tooltip
            [tooltip]="savingsPerYearTooltip"
            class="ms-1"
          ></wl-tooltip
        ></ng-template>
        <ng-template rightProjection
          ><strong
            >{{
              product.yearlySavings | currency: 'EUR' : 'symbol' : '1.0-0'
            }},-</strong
          ></ng-template
        >
      </wl-receipt-breakdown-row>
    </ng-template>
  </wl-receipt>
}
